var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "30px",
    viewBox: "0 0 23 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "org-hierarchy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "org_heirarchy-02",
    transform: "translate(-280.000000, -146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(272.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(13.000000, 0.000000)",
    fill: "#959595"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "4.21285714 0 4.21285714 4.21285714 0 4.21285714 0 5.64142857 4.21285714 5.64142857 4.21285714 9.85428571 5.64142857 9.85428571 5.64142857 5.64142857 9.85428571 5.64142857 9.85428571 4.21285714 5.64142857 4.21285714 5.64142857 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(0.000000, 10.000000)",
    stroke: "#959595",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-25",
    x: 1,
    y: 1,
    width: 12,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-25",
    x: 5,
    y: 16,
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,9.5 L5,11.5",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9.5 L9,11.5",
    id: "Line-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4.5 L9,6.5",
    id: "Line-Copy-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,4.5 L5,6.5",
    id: "Line-Copy-3",
    strokeLinecap: "square"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCustomer);
export default __webpack_public_path__ + "static/media/create_customer.0699f8bc6a028eabcd19f8ea15aa7fcc.svg";
export { ForwardRef as ReactComponent };